// MIT License. See license.txt

// for translation
tuduno._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = tuduno._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = tuduno._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = tuduno._;

tuduno.get_languages = function () {
	if (!tuduno.languages) {
		tuduno.languages = [];
		$.each(tuduno.boot.lang_dict, function (lang, value) {
			tuduno.languages.push({ label: lang, value: value });
		});
		tuduno.languages = tuduno.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return tuduno.languages;
};
